import * as React from "react"
import { Route, Switch } from "react-router-dom"
import { MetaTags } from "@digits-shared/components/MetaTags/MetaTags"
import { ProtectedRoute } from "@digits-shared/components/Router/ProtectedRoute"
import { svgIconStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDigitsFullLogo } from "@digits-shared/components/SVGIcons/digits/DigitsFullLogo.svg"
import { CopyrightFooter } from "@digits-shared/components/UI/Elements/CopyrightFooter"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { LogInScreens } from "src/frontend/components/Session/Glow/LogInScreens"
import { LogOut } from "src/frontend/components/Session/Glow/LogOut"
import { PasswordResetSteps } from "src/frontend/components/Session/Glow/PasswordReset/PasswordResetSteps"
import { StaticChromeAlerts } from "src/frontend/components/Shared/Alerts/ChromeAlerts"
import { SignUpLink } from "src/frontend/components/Shared/Glow/SignUpSignInLinks"
import routes from "src/frontend/routes"

/*
  COMPONENTS
*/

const SessionChrome = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const TopMatter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .desktop & {
    margin: 48px;
    margin-bottom: 0;
  }

  .mobile-only & {
    margin: 24px;
    margin-bottom: 0;
  }

  .tablet & {
    margin-top: 48px;
  }
`

const DigitsLogo = styled(SvgDigitsFullLogo)`
  height: 33px;
  width: auto;
  flex-shrink: 0;
  ${svgIconStyles(colors.secondary)};
`

const StyledCopyrightFooter = styled(CopyrightFooter)`
  padding: 32px 0;
`

const SessionModule: React.FC = React.memo(() => (
  <SessionChrome>
    <MetaTags>
      <meta name="theme-color" content="#FCFBFF" />
    </MetaTags>
    <TopMatter>
      <DigitsLogo />
      <Switch>
        <Route exact path={routes.login.parameterizedPath} component={SignUpLink} />
      </Switch>
    </TopMatter>
    <SessionRouter />
    <StyledCopyrightFooter />
    <StaticChromeAlerts />
  </SessionChrome>
))

const SessionRouter: React.FC = () => (
  <Switch>
    <Route exact path={routes.login.parameterizedPath} component={LogInScreens} />
    <Route exact path={routes.passwordReset.parameterizedPath} component={PasswordResetSteps} />

    <Route
      exact
      path={routes.logout.parameterizedPath}
      render={() => (
        <ProtectedRoute
          redirectTo={routes.login.generate()}
          returnToRequestPath={false}
          component={LogOut}
        />
      )}
    />
  </Switch>
)

export default SessionModule
